<div class="overlay"></div>
<div class="confirmation-panel">
  <div class="inside-panel">
    <h2>
      {{
        title !== ""
          ? labelService.getLabel(title)
          : labelService.getLabel(data.title)
      }}
    </h2>

    @if (data.infoText) {
      <p>{{ data.infoText }}</p>
    }

    <div class="panel-buttons">
      <app-button
        [color]="'white'"
        [text]="labelService.getLabel('cancel')"
        (click)="onCancel()"
      ></app-button>
      <app-button
        [color]="'white'"
        [text]="labelService.getLabel('confirm')"
        (click)="onConfirm()"
      ></app-button>
    </div>
  </div>
</div>
